<template>
  <GlassCard class="profile-retry" radius="xl" role="alert">
    <span class="profile-retry__icon"><AppIcon name="warning" :size="24" /></span>
    <p class="profile-retry__text">Не удалось загрузить профиль</p>
    <AppButton
      variant="outline"
      size="sm"
      icon="refresh"
      class="profile-retry__btn"
      :loading="session.meLoading"
      @click="retry"
    >
      Повторить
    </AppButton>
  </GlassCard>
</template>

<script setup>
/**
 * ProfileRetryCard — замена карточки профиля, когда session.loadMe() не удался и профиля нет.
 * «Повторить» перезагружает профиль; ошибку повторной попытки показывает тостом (401 — критический экран).
 *
 * <ProfileRetryCard v-if="profileFailed" />
 */
import AppButton from "@/components/ui/AppButton.vue";
import AppIcon from "@/components/ui/AppIcon.vue";
import GlassCard from "@/components/ui/GlassCard.vue";
import { useSessionStore } from "@/stores/session";
import { useToast } from "@/composables/useToast";

const session = useSessionStore();
const toast = useToast();

async function retry() {
  try {
    await session.loadMe();
  } catch (error) {
    if (error && error.status !== 401) toast.error(error.message || "Не удалось загрузить профиль");
  }
}
</script>

<style scoped>
.glass-card.profile-retry {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 112px;
}

.profile-retry__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: var(--cb-danger-soft);
  color: var(--cb-danger);
}

.profile-retry .profile-retry__btn {
  flex-shrink: 0;
  white-space: nowrap;
}

.profile-retry__text {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.35;
  color: var(--cb-text-2);
}
</style>
